<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hH31tD/tc-custom/9781429982863.jpg?1738254592882" alt="This image is the cover for the book The Elephant to Hollywood"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Elephant to Hollywood
      </h1>
      <p class="bookDescription body article font2">
        <b>The actor tells the story of his career comeback and surprising second act in a warm, funny memoir “packed with amazing anecdotes” (<i>Entertainment Weekly</i>).</b><br/><br/>When he was in his late fifties, Michael Caine believed his glamorous, rags-to-riches Hollywood career had come to an end. The scripts being sent his way were worse and worse. When one script really disappointed, he called the producer to complain about the part. The producer said, “No, no, we don’t want you for the lover, we want you for the father.”<br/><br/>Salvation came in the unlikely form of his old friend Jack Nicholson, who convinced him to give acting one more shot. What followed was not only an incredible personal transformation but also one of the most radical comebacks in film history. Learning to accept his new role both on camera and in his own life, Caine went on to win his second Oscar, be knighted by the queen, and deliver some of his best performances to date. Now he shares the spectacular story of his life: his humble upbringing in London’s poverty-stricken Elephant and Castle; his military service, marriage, and family life; lively adventures with friends; legendary meetings with fellow stars; forays as a restaurateur; and hilarious offscreen encounters from his glittering five-decade career.<br/><br/>“Caine has three things you want in a memoirist—an eye for detail, a knack for storytelling and a sense of humor about himself—and they all come out to play in <i>The Elephant to Hollywood</i>.” —<i>New York Times Book Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Caine
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?30437e41